import * as React from 'react';

import { Layout } from '../Layout';
import { FavoriteButtonContainer } from '../../containers/FavoriteButton';
import * as style from './CarouselOverlayPanel.css';
import { NewbuildingReviewsStatContainer } from '../../containers/NewbuildingReviewsStat';

export const CarouselOverlayPanel = () => {
  return (
    <Layout>
      <div className={style['rating']}>
        <NewbuildingReviewsStatContainer />
      </div>
      <div className={style['list']}>
        <div className={style['item']}>
          <FavoriteButtonContainer />
        </div>
      </div>
    </Layout>
  );
};
